import React from "react";
import { Text } from "@merge-api/merge-javascript-shared";

const EmptyCellValue = () => <Text className="text-gray-40">-</Text>;

export default EmptyCellValue;
